import { render, staticRenderFns } from "./Recommandation.vue?vue&type=template&id=7253a5e3&scoped=true&"
import script from "./Recommandation.vue?vue&type=script&lang=js&"
export * from "./Recommandation.vue?vue&type=script&lang=js&"
import style0 from "./Recommandation.vue?vue&type=style&index=0&id=7253a5e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253a5e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/_AzureDevOps/Kali_easyfert/CMS/Web/easyfert/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VProgressLinear})
